export default "__VITE_ASSET__27g_qwtn__"